export const AdvertisementLabel = () => (
  <span className='text-[10px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400'>
    Advertisement
  </span>
);
